<template>
	<div>
		<case-form :schema="schemaFamily" class="mt6" />
		<div class="fs4 fw7 lh125 mt6">
			如以上任何问题选择"是"，请提供详细资料：
		</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaFamilyList(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6 mb6">
			请提供上面未记录的其他家庭成员的当前年龄或过世年龄及过世原因：
		</div>

		<div class="fs4 fw7 lh125 mb2">母亲</div>
		<case-form :schema="schemaMotherDetails" class="mb6" />

		<div class="fs4 fw7 lh125 mb2">父亲</div>
		<case-form :schema="schemaFatherDetails" class="mb6" />

		<div class="fs4 fw7 lh125 mb2">兄弟</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaBrotherDetails(i)" :isBoxed="false" />
			</div>
		</j-accordion>

		<div class="fs4 fw7 lh125 mt6 mb2">姐妹</div>
		<j-accordion
			v-for="i in 2"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">详情</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaSisterDetails(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	computed: {
		schemaFamily() {
			return [
				{
					label: `您的任何亲生父母，兄弟姐妹是否曾被诊断出患有心脏病，中风或短暂性脑缺血发作（TIA），癌症， 糖尿病，帕金
森氏病，亨廷顿氏病，多囊肾病（PKD），阿尔茨海默氏病或任何其他遗传性疾病或病症？ 如“是”，请完成如下表
格：`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFamilyBeenDiagnosedCN`,
					props: {
						suggest: {
							typeIncludes: `hasFamilyBeenDiagnosedCN`
						},
						createOptions: {
							type: `hasFamilyBeenDiagnosedCN`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaMotherDetails() {
			return [
				{
					label: `当前年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motherCurrentAgeCN`,
					props: {
						suggest: {
							typeIncludes: `motherCurrentAgeCN`
						},
						createOptions: {
							type: `motherCurrentAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `在世或过世年龄及过世原因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0motherAgeAndCauseOfDeathCN`,
					props: {
						suggest: {
							typeIncludes: `motherAgeAndCauseOfDeathCN`
						},
						createOptions: {
							type: `motherAgeAndCauseOfDeathCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaFatherDetails() {
			return [
				{
					label: `当前年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0fatherCurrentAgeCN`,
					props: {
						suggest: {
							typeIncludes: `fatherCurrentAgeCN`
						},
						createOptions: {
							type: `fatherCurrentAgeCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `在世或过世年龄及过世原因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0fatherAgeAndCauseOfDeathCN`,
					props: {
						suggest: {
							typeIncludes: `fatherAgeAndCauseOfDeathCN`
						},
						createOptions: {
							type: `fatherAgeAndCauseOfDeathCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaFamilyList(i) {
			return [
				{
					label: `与家庭成员的关系`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyRelationship${i}CN`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyRelationship${i}CN`
						},
						createOptions: {
							type: `diagnosedFamilyRelationship${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `状况（如是癌症请包括类型）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyCondition${i}CN`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyCondition${i}CN`
						},
						createOptions: {
							type: `diagnosedFamilyCondition${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `发病年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyAgeAtOnset${i}CN`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyAgeAtOnset${i}CN`
						},
						createOptions: {
							type: `diagnosedFamilyAgeAtOnset${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `当前年龄，如在世`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyAgeIfLiving${i}CN`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyAgeIfLiving${i}CN`
						},
						createOptions: {
							type: `diagnosedFamilyAgeIfLiving${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `过世年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0diagnosedFamilyAgeAtDeath${i}CN`,
					props: {
						suggest: {
							typeIncludes: `diagnosedFamilyAgeAtDeath${i}CN`
						},
						createOptions: {
							type: `diagnosedFamilyAgeAtDeath${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaBrotherDetails(i) {
			return [
				{
					label: `当前年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0brotherCurrentAge${i}CN`,
					props: {
						suggest: {
							typeIncludes: `brotherCurrentAge${i}CN`
						},
						createOptions: {
							type: `brotherCurrentAge${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `在世或过世年龄及过世原因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0brotherAgeAndCauseOfDeath${i}CN`,
					props: {
						suggest: {
							typeIncludes: `brotherAgeAndCauseOfDeath${i}CN`
						},
						createOptions: {
							type: `brotherAgeAndCauseOfDeath${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaSisterDetails(i) {
			return [
				{
					label: `当前年龄`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sisterCurrentAge${i}CN`,
					props: {
						suggest: {
							typeIncludes: `sisterCurrentAge${i}CN`
						},
						createOptions: {
							type: `sisterCurrentAge${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `在世或过世年龄及过世原因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0sisterAgeAndCauseOfDeath${i}CN`,
					props: {
						suggest: {
							typeIncludes: `sisterAgeAndCauseOfDeath${i}CN`
						},
						createOptions: {
							type: `sisterAgeAndCauseOfDeath${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
